// extracted by mini-css-extract-plugin
export default {"table_container":"WOSummary_table_container__-4rtF","table_title":"WOSummary_table_title__1Az7W","overdue_cell":"WOSummary_overdue_cell__GKjex"};